import React from "react"
import NavBarItem from "../components/NavBarItem"
import {connect} from 'react-redux'
import {Map} from 'immutable'
import {setFileName} from '../actions'
import {toggleModal, clearActions} from '../actions'
import {Modals} from "../constants"
import {tooltips} from "../constants"

const onClick = (actions, dispatch) => {
    if(actions === Map({})){
        dispatch(setFileName(''))
    } else{
        dispatch(toggleModal({"screen":"newDocModal", "modal": Modals.NewDocument, "success":{screen:"default", action: [clearActions(), setFileName('')]}}))
    }
}

const NewDocument= ({name, actions, dispatch, icon, newDocConfirmed }) => {
    return (<NavBarItem onClick = {() => onClick(actions, dispatch) } name={name} tooltip={tooltips.NewDocument} icon={icon}/>)
}

function mapStateToProps(state){
    return {
        actions : state.buttonActions.present
    }
}

export default connect(mapStateToProps)(NewDocument)